/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Region_ThoracicInputs */

const en_us2_bodymap_region_thoracic = /** @type {(inputs: Bodymap_Region_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upper back`)
};

const pt_br2_bodymap_region_thoracic = /** @type {(inputs: Bodymap_Region_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costas (parte alta)`)
};

const es_419_bodymap_region_thoracic = /** @type {(inputs: Bodymap_Region_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espalda alta`)
};

const pt_pt2_bodymap_region_thoracic = /** @type {(inputs: Bodymap_Region_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costas (parte superior)`)
};

const fr_fr2_bodymap_region_thoracic = /** @type {(inputs: Bodymap_Region_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haut du dos`)
};

const de_de2_bodymap_region_thoracic = /** @type {(inputs: Bodymap_Region_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberer Rücken`)
};

const it_it2_bodymap_region_thoracic = /** @type {(inputs: Bodymap_Region_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte alta della schiena`)
};

/**
* | output |
* | --- |
* | "Upper back" |
*
* @param {Bodymap_Region_ThoracicInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_region_thoracic = /** @type {((inputs?: Bodymap_Region_ThoracicInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Region_ThoracicInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_region_thoracic(inputs)
	if (locale === "es-419") return es_419_bodymap_region_thoracic(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_region_thoracic(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_region_thoracic(inputs)
	if (locale === "de-DE") return de_de2_bodymap_region_thoracic(inputs)
	if (locale === "it-IT") return it_it2_bodymap_region_thoracic(inputs)
	return en_us2_bodymap_region_thoracic(inputs)
});
export { bodymap_region_thoracic as "bodymap.region.thoracic" }